import {AbstractPart} from "./AbstractPart";
import {nsForm} from "../../nsForm";
import {IFormPartParameters} from "./index";
import str2Bool = nsForm.str2Bool;
import checkboxHtml from './checkbox.html?raw';

export let template = checkboxHtml;

export class viewModel extends AbstractPart {
    private label: string;

    constructor(params: IFormPartParameters) {
        super(params);
        this.value(str2Bool(this.parameters[2] ?? ''));
        this.label = this.parameters[3] ?? '';
    }
}
